// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-width: 240px;
  --bg-muted: #f5f6fb;
  --text-muted: #6c757d;
  --brand-primary: #1d4ed8;
  --brand-accent: #f59e0b;
}

body {
  margin: 0;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background-color: var(--bg-muted);
  color: #101828;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  background-color: var(--bg-muted);
}

.sidebar {
  width: var(--sidebar-width);
  background: #0f172a;
  color: #e2e8f0;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.sidebar .brand {
  font-weight: 600;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sidebar .nav-link {
  color: #cbd5f5;
  border-radius: 0.5rem;
  padding: 0.6rem 0.75rem;
  margin-bottom: 0.35rem;
  transition: background 0.2s ease, color 0.2s ease;
}

.sidebar .nav-link.active,
.sidebar .nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.main-panel {
  flex: 1;
  padding: 2rem;
  background: #fff;
  border-top-left-radius: 36px;
  border-bottom-left-radius: 36px;
  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.08);
}

.section-card {
  background: #fff;
  border: 1px solid #edf0f7;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.05);
}

.kpi-card {
  border-radius: 1rem;
  border: 1px solid #edf0f7;
  background: linear-gradient(145deg, #ffffff, #f4f6ff);
  padding: 1rem 1.25rem;
}

.invoice-pill {
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-paid {
  background: #dcfce7;
  color: #15803d;
}
.badge-issued {
  background: #dbeafe;
  color: #1d4ed8;
}
.badge-pending {
  background: #fef9c3;
  color: #854d0e;
}
.badge-overdue {
  background: #fee2e2;
  color: #b91c1c;
}

.table thead {
  background: #f8fafc;
}

.table thead th {
  border: none;
  color: #475467;
  font-weight: 600;
}

.table tbody td {
  vertical-align: middle;
}

.timeline-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--brand-primary);
}

.alert-card {
  border-left: 4px solid var(--brand-accent);
}

.detail-panel-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: flex-end;
  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(1px);
  z-index: 1050;
}

.detail-panel {
  width: min(420px, 90vw);
  background: #fff;
  padding: 1.75rem;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

.detail-panel-body {
  max-height: 80vh;
  overflow-y: auto;
}

.clickable-row {
  cursor: pointer;
}
.clickable-row:hover {
  background-color: #f8fafc;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,0FAA0F;EAC1F,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;;EAEE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[":root {\n  --sidebar-width: 240px;\n  --bg-muted: #f5f6fb;\n  --text-muted: #6c757d;\n  --brand-primary: #1d4ed8;\n  --brand-accent: #f59e0b;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background-color: var(--bg-muted);\n  color: #101828;\n}\n\n.app-shell {\n  min-height: 100vh;\n  display: flex;\n  background-color: var(--bg-muted);\n}\n\n.sidebar {\n  width: var(--sidebar-width);\n  background: #0f172a;\n  color: #e2e8f0;\n  padding: 1.5rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.sidebar .brand {\n  font-weight: 600;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.sidebar .nav-link {\n  color: #cbd5f5;\n  border-radius: 0.5rem;\n  padding: 0.6rem 0.75rem;\n  margin-bottom: 0.35rem;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.sidebar .nav-link.active,\n.sidebar .nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.main-panel {\n  flex: 1;\n  padding: 2rem;\n  background: #fff;\n  border-top-left-radius: 36px;\n  border-bottom-left-radius: 36px;\n  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.08);\n}\n\n.section-card {\n  background: #fff;\n  border: 1px solid #edf0f7;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.05);\n}\n\n.kpi-card {\n  border-radius: 1rem;\n  border: 1px solid #edf0f7;\n  background: linear-gradient(145deg, #ffffff, #f4f6ff);\n  padding: 1rem 1.25rem;\n}\n\n.invoice-pill {\n  padding: 0.15rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.badge-paid {\n  background: #dcfce7;\n  color: #15803d;\n}\n.badge-issued {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.badge-pending {\n  background: #fef9c3;\n  color: #854d0e;\n}\n.badge-overdue {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.table thead {\n  background: #f8fafc;\n}\n\n.table thead th {\n  border: none;\n  color: #475467;\n  font-weight: 600;\n}\n\n.table tbody td {\n  vertical-align: middle;\n}\n\n.timeline-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--brand-primary);\n}\n\n.alert-card {\n  border-left: 4px solid var(--brand-accent);\n}\n\n.detail-panel-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  justify-content: flex-end;\n  background: rgba(15, 23, 42, 0.35);\n  backdrop-filter: blur(1px);\n  z-index: 1050;\n}\n\n.detail-panel {\n  width: min(420px, 90vw);\n  background: #fff;\n  padding: 1.75rem;\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n}\n\n.detail-panel-body {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.clickable-row {\n  cursor: pointer;\n}\n.clickable-row:hover {\n  background-color: #f8fafc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
